// required to register them for JSON serialize/deserialize
//
export default [
  require("./BlurFilter"),
  require("./FanoutFilter"),
  require("./FillColorFilter"),
  require("./Filter"),
  require("./FontColorFilter"),
  require("./FontSizeFilter"),
  require("./LinearGradientFilter"),
  require("./OpacityFilter"),
  require("./OutlineStrokeFilter"),
  require("./PortDirectionFilter"),
  require("./PortTypeFilter"),
  require("./PositionFilter"),
  require("./RadiusFilter"),
  require("./SizeFilter"),
  require("./StrokeFilter"),
  require("./TextLinearGradientFilter")
]
